import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkFlowSettingService {
  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }
  
  getAll(): any {
    return this.http.get(`${environment.apiWfl}/WorkflowSetting/GetAllWorkFlowSetting`);
  }

  getDefinition() {
    return this.http.get(`${environment.apiWfl}/WorkflowSetting/GetWorkFlowDefinition`);
  }

  getWorkflowByWorkflowType(id:number) {
    return this.http.get(`${environment.apiWfl}/WorkflowSetting/GetWorkflowByWorkflowType?TypeId=${id}`);
  }

  saveRecord(data: any) {
      return this.http.post(`${environment.apiWfl}/WorkflowSetting/CreateWorkFlowSetting`, data);
  }

  deleteRecord(data: any) {
    return this.http.post(`${environment.apiWfl}/WorkflowSetting/DeleteWorkFlowSetting`, data);
  }
}
